import { useCreateRoomMutation } from '~entities/rooms/api/create-room';
import { useGetAllRooms } from '~entities/rooms/api/get-all-rooms';

import Creatable from '~shared/components/select/creatable';

export interface RoomOption {
  label: string | null;
  value: string | null;
}

export interface RoomSelectorProps {
  value: RoomOption | null;
  onChange: (value: RoomOption | null) => void;
}

export const RoomSelector = ({ value, onChange }: RoomSelectorProps) => {
  const mutation = useCreateRoomMutation();
  const { data, isFetching } = useGetAllRooms();
  const options = data?.map((room) => {
    return {
      label: room.fieldName,
      value: room._id,
    };
  });

  return (
    <Creatable
      value={value}
      onChange={(option) => {
        const opt = option as RoomOption | null;
        onChange(opt);
      }}
      onCreateOption={async (inputValue: string) => {
        const room = await mutation.mutateAsync({ fieldName: inputValue });
        onChange({ label: room.fieldName, value: room._id });
      }}
      placeholder='Select Rooms'
      options={options}
      isLoading={isFetching}
    />
  );
};
